import {GET, GET_CSV, POST} from './http';

const safe = value => encodeURIComponent(String(value));

export const Machines = token => GET('material-traceability/machines', token);
export const SelectMachine = (token, machineId) => POST(`material-traceability/machines/${safe(machineId)}/select`, {}, token);
export const ActiveRoll = (token, machineId) => GET(`material-traceability/machines/${safe(machineId)}/active-roll`, token);
export const ChangeRoll = (token, machineId, rollNumber) => POST(
    `material-traceability/machines/${safe(machineId)}/change-roll`,
    {rollNumber},
    token
);
export const OrderInfo = (token, machineId, orderId) => GET(
    `material-traceability/machining/order/${safe(orderId)}?machineId=${safe(machineId)}`,
    token
);
export const Process = (token, payload) => POST('material-traceability/machining/process', payload, token);
export const Recent = (token, machineId, limit = 5) => GET(
    `material-traceability/machines/${safe(machineId)}/recent?limit=${safe(limit)}`,
    token
);
export const History = (token, filters = {}) => {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value).trim() !== '') query.set(key, value);
    });
    return GET(`material-traceability/history?${query.toString()}`, token);
};
export const HistoryCsv = (token, filters = {}) => {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value).trim() !== '') query.set(key, value);
    });
    return GET_CSV(`material-traceability/history.csv?${query.toString()}`, token);
};
